import { render } from "./WordSkill.vue?vue&type=template&id=f598997a"
import script from "./WordSkill.vue?vue&type=script&lang=js"
export * from "./WordSkill.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__